import MoneyOffTwoToneIcon from "@mui/icons-material/MoneyOffTwoTone";
import PaidRoundedIcon from "@mui/icons-material/PaidRounded";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isMainSubdomain } from "src/GeneralHelper";
import HeaderNotifications from "./Notifications";

function HeaderButtons() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const disableMenu = isMainSubdomain();

	return (
		<Box sx={{ mr: 1 }}>
			<Box sx={{ mx: 0.5 }} component="span">
				<Tooltip arrow title={t("Expenses")}>
					<IconButton color="info" onClick={() => navigate("/expenses")} disabled={disableMenu}>
						<MoneyOffTwoToneIcon />
					</IconButton>
				</Tooltip>
			</Box>
			<Box sx={{ mx: 0.5 }} component="span">
				<Tooltip arrow title={t("MakeASale")}>
					<IconButton color="success" onClick={() => navigate("/make-a-sale")} disabled={disableMenu}>
						<PaidRoundedIcon />
					</IconButton>
				</Tooltip>
			</Box>
			<Box sx={{ mx: 0.5 }} component="span">
				<HeaderNotifications />
			</Box>
		</Box>
	);
}

export default HeaderButtons;
